export enum UploadFileContentType {
	ConfirmingDocuments_Type1_XLSX = 'ConfirmingDocuments_Type1_XLSX',
	ConfirmingDocuments_Type2_CSV = 'ConfirmingDocuments_Type2_CSV',
	ConfirmingSuppliers_Type1_XLSX = 'ConfirmingSuppliers_Type1_XLSX',
	FactoringCreditAssignmentDates = 'FactoringCreditAssignmentDates',
	FactoringDocuments_Type1_XLSX = 'FactoringDocuments_Type1_XLSX',
}
